import gql from 'graphql-tag';

export const embeddedIntegrationEmailFragment = gql`
  fragment embeddedIntegrationEmailFragment on IntegrationEmail {
    accountID
    dokkioClass
    integrationID
    remoteID
    providerMessageID
    providerThreadID
    sentAt
    receivedAt
    subject
    toAddress
    fromAddress
    ccAddress
    snippet
    isRead
  }
`;
export default embeddedIntegrationEmailFragment;
